import { Component, input, output } from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { UmssIconComponent } from '../icon/icon.component';

export interface BreadcrumbItem {
  label: string;
  url?: string;
  /**
   * Query params for `url`. They have to be passed separately: `routerLink`
   * takes a string as a single path segment, so a `?` embedded in `url` is
   * encoded and the link resolves to a route that does not exist.
   */
  queryParams?: Params;
  iconName?: string;
  active?: boolean;
}

@Component({
  selector: 'umss-breadcrumb',
  imports: [RouterLink, UmssIconComponent],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class UmssBreadcrumbComponent {
  items = input<BreadcrumbItem[]>([]);
  separator = input<string>('›');
  showFirstItemIcon = input<boolean>(false);
  firstItemIconName = input<string>('phosphorHouse');

  itemClick = output<BreadcrumbItem>();

  onItemClick(item: BreadcrumbItem, event: Event): void {
    if (item.active) {
      event.preventDefault();
      return;
    }

    if (item.url) {
      this.itemClick.emit(item);
    } else {
      event.preventDefault();
      this.itemClick.emit(item);
    }
  }

  isLastItem(index: number): boolean {
    return index === this.items().length - 1;
  }
}
